export default __webpack_public_path__ + "static/media/11.166b708f.jpeg";